import {
  Children,
  cloneElement,
  ComponentRef,
  forwardRef,
  HTMLProps,
  isValidElement,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { Button, ButtonProps } from "../Button";

type ToggleElement = ComponentRef<typeof Button>;

type ToggleProps = {
  pressed?: boolean;
  defaultPressed?: boolean;
  onPressedChange?: (pressed: boolean) => void;
} & ButtonProps;

export const Toggle = forwardRef<ToggleElement, ToggleProps>((props, ref) => {
  const {
    pressed: pressedProp,
    defaultPressed,
    onPressedChange,
    children,
    ...buttonProps
  } = props;

  const [pressed, setPressed] = useState(pressedProp ?? defaultPressed);

  useEffect(() => {
    setPressed(pressedProp);
  }, [pressedProp]);

  const childrenWithProps = Children.map(children, (child) =>
    isValidElement(child)
      ? cloneElement(child, {
          "data-state": pressed ? "on" : "off",
        } as PropsWithChildren<HTMLProps<HTMLElement>>)
      : child
  );

  return (
    <Button
      aria-pressed={pressed}
      {...buttonProps}
      ref={ref}
      data-state={pressed ? "on" : "off"}
      data-disabled={props.disabled ? "" : undefined}
      onClick={(e) => {
        if (props.disabled) return;

        props.onClick?.(e);
        setPressed(!pressed);
        onPressedChange?.(!pressed);
      }}
    >
      {childrenWithProps}
    </Button>
  );
});

export default {};
